import { handleResponse, handleError, headerset } from "../apiUtils";

export function fetchCodiciAI() {
	const url: string = process.env.API_URL + "/api/anagrafiche/codiciAI/";
	return fetch(url, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}
